module.exports = __webpack_public_path__ + "img/exit-full-screen.5d8fa210.svg";